export const REQUIRED = 'required'
export const MIN_LENGTH = 'minLength'
export const MAX_LENGTH = 'maxLength'
export const MIN_VALUE = 'minValue'
export const MAX_VALUE = 'maxValue'
export const BETWEEN = 'between'
export const BETWEEN_LENGTH = 'betweenLength'

export const ALPHA_NUM = 'alphaNum'
export const INTEGER = 'integer'
export const EMAIL = 'email'
export const URL = 'url'
export const HIRAGANA = 'hiragana'

export const SAME_AS = 'sameAs'
export const REQUIRED_AT_LEAST_N = 'requiredAtLeastN'
export const END_GREATER_THAN_START = 'endGreaterThanStart'
